import React from "react";
import PageHeader from "../components/PageHeader";
import CrudTable from "../components/CrudTable";

export default function DevirBiskuvi() {
  const columns = [
    { key: "tarih", label: "Tarih" },
    { key: "kalip_kodu", label: "Kalıp Kodu", mono: true },
    { key: "aciklama", label: "Ürün Açıklaması" },
    { key: "devir_adet", label: "Devir Bisküvi Adet", num: true },
    { key: "notlar", label: "Notlar" },
  ];
  const fields = [
    { key: "tarih", label: "Tarih", type: "date" },
    { key: "kalip_kodu", label: "Kalıp Kodu", type: "kalip", mono: true, required: true, span: 2, fills: { urun_aciklamasi: "aciklama" } },
    { key: "aciklama", label: "Ürün Açıklaması (otomatik)", type: "text", readOnly: true, span: 2 },
    { key: "devir_adet", label: "Devir Bisküvi Adet", type: "number", required: true },
    { key: "notlar", label: "Notlar", type: "textarea", span: 2 },
  ];
  return (
    <>
      <PageHeader title="Devir Bisküvi" subtitle="Manuel devir bisküvi girişi — kalıp koduna göre Bisküvi Stok'a eklenir" />
      <CrudTable endpoint="/entity/devir" columns={columns} fields={fields} titleSingular="Devir Kaydı"
        printTitle="Devir Bisküvi" dateField="tarih" exportKind="devir" />
    </>
  );
}
